import { render, staticRenderFns } from "./PageTileNavigation.vue?vue&type=template&id=05c247e7&lang=pug"
import script from "./PageTileNavigation.vue?vue&type=script&lang=ts"
export * from "./PageTileNavigation.vue?vue&type=script&lang=ts"
import style0 from "./PageTileNavigation.vue?vue&type=style&index=0&id=05c247e7&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Block: require('/app/components/generic/Block.vue').default,Icon: require('/app/components/vantone/Icon.vue').default})
